// extracted by mini-css-extract-plugin
export default {"text":"LinkTypeAssetLibrary_text__IOEvf","salesPreview":"LinkTypeAssetLibrary_salesPreview__cCAqh","empty":"LinkTypeAssetLibrary_empty__j97TA"};